import * as types from './types';
import { loading } from 'State/actions';
import { has } from 'lodash';
import { toastInfo, toastError } from 'Common/ToastHelper';
import { FileDownloadTypes } from 'Common/Constants/Enumeration/CommonEnum';
import { excelReportFileName } from '../../helpers/constants';

export const getInitialData = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.MASTER_ROSTER_FETCHING, true));

    try {
      const grades = await MPWWebApi.getGeneric('grade');
      const releaseCategories = await MPWWebApi.getGeneric(
        'ControlInfo/ReleaseCategory'
      );
      dispatch({
        type: types.MASTER_ROSTER_GET_DATA,
        payload: {
          grades: grades.data.Data,
          releaseCategories: releaseCategories.data.Data,
        },
      });
    } catch (error) {
      if (has(error, 'response.data.Errors')) {
        dispatch({
          type: types.MASTER_ROSTER_FETCH_ERROR,
          payload: error.response.data.Errors,
        });
      } else {
        toastError(error.response.statusText);
      }
    }

    dispatch(loading(types.MASTER_ROSTER_FETCHING, false));
  };
};

export const getReport = data => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.MASTER_ROSTER_FETCHING, true));

    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'reports/masterroster',
        data
      );

      if (!response.data.Data) {
        toastInfo('No data found!');
      } else {
        dispatch({
          type: types.MASTER_ROSTER_GET_REPORT,
          payload: response.data.Data,
        });
      }
    } catch (error) {
      if (has(error, 'response.data.Errors')) {
        dispatch({
          type: types.MASTER_ROSTER_FETCH_ERROR,
          payload: error.response.data.Errors,
        });
      } else {
        toastError(error.response.statusText);
      }
    }

    dispatch(loading(types.MASTER_ROSTER_FETCHING, false));
  };
};

export const getExcelFile = data => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.MASTER_ROSTER_FETCHING, true));
      const response = await MPWWebApi.postDownloadFile(
        'reports/masterroster',
        excelReportFileName,
        data,
        FileDownloadTypes.ExcelOpenXML
      );
      dispatch({
        type: types.MASTER_ROSTER_GET_EXCEL_REPORT,
        payload: response,
      });
    } catch (error) {
      if (has(error, 'response.data.Data')) {
        dispatch({
          type: types.MASTER_ROSTER_FETCH_ERROR,
          payload: error.response.data.Data,
        });
      } else {
        toastError(error.response);
      }
    } finally {
      dispatch(loading(types.MASTER_ROSTER_FETCHING, false));
    }
  };
};

export const clearReport = () => {
  return {
    type: types.MASTER_ROSTER_GET_REPORT,
  };
};

export const clearErrors = () => {
  return {
    type: types.MASTER_ROSTER_FETCH_ERROR,
  };
};

export const clearExcelReport = () => {
  return {
    type: types.MASTER_ROSTER_CLEAR_EXCEL_REPORT,
  };
};



// WEBPACK FOOTER //
// ./src/pages/masterroster/state/masterroster/actions.js